import { createSlice } from "@reduxjs/toolkit"
import { uploadImage, uploadThumbnail } from "../actions/upload";

const INITIAL_STATE = {
    isLoading: false,
    isError: false,
    urls: [],
}

export const uploadSlice = createSlice({
    name: "upload",
    initialState: INITIAL_STATE,
    extraReducers: (builder) => {
        builder.addCase(uploadImage.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(uploadImage.fulfilled, (state, action) => {
            state.isLoading = false;
            state.urls = action.payload.data?.urls
        })
        builder.addCase(uploadImage.rejected, (state) => {
            state.isError = true
        });

        builder.addCase(uploadThumbnail.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(uploadThumbnail.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        builder.addCase(uploadThumbnail.rejected, (state) => {
            state.isError = true
        })
    }
})

export default uploadSlice.reducer;